import { StyleSheet, Platform } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getWorldCupSkeletonStyles = (theme: Theme, windowWidth = 390) => {
  const wcWebMaxWidth = Platform.OS === 'web'
    ? (windowWidth >= 1024 ? 880 : windowWidth >= 768 ? 700 : 560)
    : undefined;

  return StyleSheet.create({
    flex1: {
      flex: 1,
    },
    container: {
      flex: 1,
      backgroundColor: theme.background.primary,
      paddingHorizontal: 16,
      paddingTop: 14,
      gap: 10,
      ...(wcWebMaxWidth != null && {
        maxWidth: wcWebMaxWidth,
        width: '100%' as never,
        alignSelf: 'center' as const,
      }),
    },
    podiumRow: {
      flexDirection: 'row',
      gap: 8,
    },
    podiumRowAligned: {
      flexDirection: 'row',
      gap: 8,
      alignItems: 'flex-end',
    },
    pillsRow: {
      flexDirection: 'row',
      gap: 8,
    },
    sectionLabel: {
      marginTop: 4,
      marginBottom: 4,
    },
  });
};
